import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .ActionsTab {
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;

    @include respond-to(xs) {
      flex-direction: column;
    }

    &__trading-date {
      display: flex;
      align-items: center;

      :global(.DateRangeField) {
        min-width: 230px;
        margin-bottom: 0;
      }

      :global(.DateRangeField__picker) {
        height: 40px;
        border-radius: 8px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 0 12px;
        display: flex;
        align-items: center;
        gap: 8px;
        white-space: nowrap;
        cursor: pointer;
      }

      :global(.DateRangeField__inner) {
        position: absolute;
        z-index: 100;
      }

      @include respond-to(xs) {
        width: 100%;

        :global(.DateRangeField) {
          width: 100%;
          min-width: auto;
        }
      }
    }

    &__filter-choose {
      padding: 10px;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      border: 1px solid #f3f3f3;
      background: #fff;
      cursor: pointer;

      @include respond-to(xs) {
        order: 2;
      }
    }

    &__filters-left {
      flex-grow: 1;
      gap: 4px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;

      .ActionsTab__actions-wrapper {
        display: flex;
        gap: 8px;
        align-items: center;
        flex-shrink: 0;

        @include respond-to(xs) {
          width: 100%;
          justify-content: space-between;
        }
      }

      .ActionsTab__search-wrapper {
        display: flex;
        gap: 4px;
        align-items: center;
        flex-grow: 0;
        flex-shrink: 0;
        padding-right: 0 !important;

        @include respond-to(xs) {
          width: 100%;

          :global(.CRMSearchBar) {
            width: 100%;
            max-width: 100%;
          }
        }
      }

      :global(.BaseStaticSelect) {
        flex-shrink: 0;
        min-width: 250px;
        max-width: 300px;
        position: relative;
        z-index: 10;
      }

      :global(.CRMSearchBar) {
        flex-grow: 0;
        flex-shrink: 0;
        width: 250px;
        margin-right: 4px;
      }

      @include respond-to(xs) {
        width: 100%;
        flex-direction: column;
        align-items: stretch;
        gap: 12px;

        :global(.BaseStaticSelect),
        :global(.CRMSearchBar),
        .ActionsTab__trading-date,
        .ActionsTab__search-wrapper {
          width: 100%;
        }

        :global(.BaseStaticSelect) {
          order: 1;
        }

        .ActionsTab__search-wrapper {
          order: 2;
        }

        .ActionsTab__trading-date {
          order: 3;
        }
      }
    }

    &__contacts {
      @include respond-to(xs) {
        order: 4;
        width: 100%;

        // 按钮行
        > div:first-child {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;

          :global(.BaseButton) {
            flex: 1;
            min-width: 0;
          }
        }
      }
    }

    &__get-client-mobile {
      flex-shrink: 0;

      :global(.GetClientButton) {
        display: flex !important;
        white-space: nowrap;
      }
    }

    &__filter-row-mobile {
      display: contents; // web 端保持原有布局

      @include respond-to(xs) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        width: 100%;

        .ActionsTab__filter-select {
          flex: 1;
          min-width: 0;
        }
      }
    }

    &__uploadContacts-mobile {
      width: 44px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      background: #0aa1e2;
    }

    &__filter-choose {
      padding: 10px;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      border: 1px solid #f3f3f3;
      background: #fff;
      cursor: pointer;

      @include respond-to(xs) {
        order: 2;
      }
    }

    &__filters-right {
      flex-grow: 1;
      gap: 24px;
      display: flex;
      justify-content: flex-end;
      @include respond-to(xs) {
        width: 100%;
        flex-direction: column;
        row-gap: 12px;

        .ActionsTab__filter-row-mobile {
          width: 100%;
        }

        .ActionsTab__filter-select {
          width: 100%;
        }

        .ActionsTab__contacts {
          width: 100%;
        }
      }
    }

    :global(.CustomFilterSelect) {
      min-width: 150px;
      @include respond-to(xs) {
        min-width: 100%;
      }
    }
  }

  .ActionsTab__ModalButtons {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    gap: 16px;
  }

  :global(.FilterChooseModal) {
    :global(.BasicModal__inner) {
      padding: 24px 0 !important;
    }
  }

  :global(.FilterChooseModal.ReactModal__Content) {
    padding-bottom: 0 !important;
  }

`;

export { staticStyles };
